module.exports = __webpack_public_path__ + "res/28-img_top_center_1.c8048897224f75135b6f0a69be8168b3.png";